import { formatCurrency } from "../constants/sovSetupData";

interface VarianceAlertProps {
  total: number;
  variance: number;
}

export default function VarianceAlert({ total, variance }: VarianceAlertProps) {
  if (Math.abs(variance) < 0.01) {
    return (
      <div className="sovVarianceAlert ok">
        <span className="icon">✅</span>
        <p>
          <strong>SOV total matches contract amount.</strong>{" "}
          {formatCurrency(total)} - ready to submit for CSC review.
        </p>
      </div>
    );
  }

  return (
    <div className="sovVarianceAlert err">
      <span className="va-icon">🛑</span>
      <p>
        <strong>SOV total does not match contract amount.</strong> Variance is{" "}
        {variance > 0 ? "+" : ""}
        {formatCurrency(variance)}. Adjust line item values before submitting.
        CSC will not accept a mismatched SOV.
      </p>
    </div>
  );
}
